var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titleNext"},[_vm._v(" "+_vm._s(_vm.desc)),_c('i',{staticClass:"el-icon-arrow-right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }